import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function ChatContacts({ handleContactClick, data }) {
  const [expandedCompanies, setExpandedCompanies] = useState({});

  if (!data || typeof data !== "object") {
    return <p>No contacts available</p>;
  }

  const handleToggleCompany = (companyName) => {
    setExpandedCompanies((prev) => ({
      ...prev,
      [companyName]: !prev[companyName],
    }));
  };

  return (
    <div>
      {Object.keys(data).map((companyName) => (
        <div key={companyName} className="mb-3 border-2 shadow-md">
          <h2
            className="font-bold cursor-pointer flex items-center justify-between"
            onClick={() => handleToggleCompany(companyName)}
          >
            {companyName}
            <span>
              {expandedCompanies[companyName] ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </span>
          </h2>

          {expandedCompanies[companyName] && (
            <ul>
              {data[companyName]?.users.map((contact) => (
                <li
                  key={contact?.id}
                  className="px-1 hover:bg-gray-300 cursor-pointer rounded"
                  onClick={() =>
                    handleContactClick(contact?.id, contact?.firstname)
                  }
                >
                  <h2 className="flex gap-2 items-center justify-between">
                    {contact?.firstname}
                    {contact?.messages.filter(
                      (item) =>
                        item.role === "receiver" && Number(item?.is_read) === 0
                    ).length > 0 && (
                      <span className="text-[8px] p-1 w-3 h-3 bg-green-500 rounded-full flex justify-center items-center text-white">
                        {
                          contact?.messages.filter(
                            (item) =>
                              item.role === "receiver" &&
                              Number(item?.is_read) === 0
                          ).length
                        }
                      </span>
                    )}
                  </h2>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

export default ChatContacts;
